import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'ui-form-description-panel',
  template: `{{ description() }}`,
  styleUrls: ['./form-description-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    // the hook the themes place the description text of an input with
    class: 'form-item-description',
  },
})
export class FormDescriptionPanelComponent {
  public readonly description: InputSignal<string> = input.required();
}
